import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '../material';
import { DialogModel } from '../models/dialog.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'pop-up-dialog',
  imports: [MatDialogModule, MatFormFieldModule],
  templateUrl: './pop-up-dialog.component.html',
  styleUrl: './pop-up-dialog.component.scss',
})
export class PopUpDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PopUpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogModel,
  ) {
    dialogRef.disableClose = true;
  }

  onCancel() {
    this.dialogRef.close();
  }
}
